import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import axios from "axios";

const EmailLoginForm = ({ onBack, onSignup }) => {
    const history = useHistory();
  
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleLogin = async (e) => {
        e.preventDefault();
        setError("");

        try {
            const response = await axios.post("/api/auth/login", {
                email,
                password,
            });

            if (response.data.success) {
                // Use the same pattern as OAuth - full page navigation
                window.location.href = "/profile";
            } else {
                setError(response.data.message || "Login failed");
            }
        } catch (err) {
            console.error("Login error:", err);
            setError(err.response?.data?.message || "An error occurred");
        }
    };
  
    return (
      <Box>
        <Typography variant="h5" align="center" mb={3}>
          Login with Email
        </Typography>
  
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
  
        <form onSubmit={handleLogin}>
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <TextField
                fullWidth
                label="Email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Grid>
  
            <Grid item>
              <TextField
                fullWidth
                label="Password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Grid>
  
            <Grid item>
              <Button type="submit" variant="contained" fullWidth>
                Log In
              </Button>
              <Button fullWidth variant="text" onClick={onSignup}>Need an account? Sign up</Button>
              <Button fullWidth variant="text" onClick={onBack}>← Back</Button>
            </Grid>
          </Grid>
        </form>
      </Box>
    );
  };
  
  export default EmailLoginForm;
